export const capitalizeWords = (str) => {
  return str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (match) => match.toUpperCase());
};

export function isValidString(data) {
  return typeof data === 'string' && data.length > 0;
}
